import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from '../../core/services/http-data.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutoevaluationsService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/surveys');
  }

  getGameQuestions(gameId) {
    return lastValueFrom(this.http.get(`${this.baseUrl}/prepost/${gameId}`))
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }
}
